import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";


@Component({
  selector: 'app-change-card-pin',
  templateUrl: './change-card-pin.component.html',
  standalone:false,
  styleUrls: ['./change-card-pin.component.scss']
})

export class ChangeCardPinComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  constructor(private router:Router, private location: Location) { }
  back() {
    this.location.back()
  }

  ngOnInit(): void {
  }

  showModal(num) {
    
    this.modalObservable.next(num);
  }



}
